import { ReactElement } from "react";
import { DashboardSchemaType, IAcquisitionCell, ICell, IDashboard, IDashboardResult } from "../types";
import CellComponent from "./cellComponent";
import { IDictionary, IParentSize } from "../../../types";

interface IProps {
  parentSize: IParentSize;
  cells: (ICell | IAcquisitionCell)[];
  responseData: IDashboardResult | null;
  loading: IDictionary<boolean>;
  dashboard: IDashboard;
  setDashboard: (dashboard: IDashboard) => void;
  setSelectedCell: (dashboard: ICell | IAcquisitionCell | null) => void;
  isMaximized: boolean;
  schemas: Record<DashboardSchemaType, any>;
  onUpdatePalette: (p: IDictionary<string>, hasChange: boolean) => void;
  marqueeMode?: boolean;
}

const RowComponent = ({ cells, responseData, loading, parentSize, dashboard, setDashboard,
  setSelectedCell, isMaximized, schemas, onUpdatePalette, marqueeMode }: IProps): ReactElement => {
  const layoutStyle = {
    gridTemplateColumns: `repeat(${cells.length}, 1fr)`,
    gridTemplateRows: "1fr",
    gridColumnGap: "1em",
  };

  const width = parentSize.width / cells.length - 24;

  return (
    <div className="display-grid" style={layoutStyle}>
      { cells.map((cell) =>
        <CellComponent key={`cell-${cell.key}`} cell={cell} marqueeMode={marqueeMode}
          responseData={responseData} loading={loading[cell.key]} parentSize={{ width, height: parentSize.height }}
          dashboard={dashboard} setDashboard={setDashboard} setSelectedCell={setSelectedCell}
          isMaximized={isMaximized} schemas={schemas} onUpdatePalette={onUpdatePalette}/>
      )}
    </div>
  );
};

export default RowComponent;
